import { memo } from 'react';
import FJTextToImageLeft from '../view/FJTextToImageLeft';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useDispatch, useSelector } from 'react-redux';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import { useMemo } from 'react';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';

const FJTextToImageLeftContainer = memo(function FJTextToImageLeftContainer() {
    useLocalStore();

    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.textToImage.taskStatus);
    const freeNumCreation = useSelector(state => state.textToImage.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const curResolution = useSelector(state => state.textToImage.curResolution);
    const curModel = useSelector(state => state.textToImage.curModel);
    const generateNumber = useSelector(state => state.textToImage.generateNumber);

    const curModelData = useMemo(() => {
        return FJTextToImageDataConfig.MODELS.find(item => item.value === curModel);
    }, [curModel]);

    const useCredit = useMemo(() => {
        const modelUseCredit =
            (curModelData?.creditPriceLevels && curModelData?.creditPriceLevels?.[curResolution]) ||
            curModelData?.useCredit ||
            0;
        const useCredit = modelUseCredit * generateNumber;

        return useCredit;
    }, [curModelData, generateNumber, curResolution]);

    const generate = () => {
        dispatch(FJActionTextToImage.generateAction());
    };

    return (
        <FJTextToImageLeft
            generate={generate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            isProjectLoading={isProjectLoading}
            useCredit={useCredit}
            creditNumber={creditNumber}
            isShowStylePrompt={curModelData?.supportStylePrompt}
            isShowImageUploader={curModelData?.supportImageReference}
            curModel={curModel}
        />
    );
});

export default FJTextToImageLeftContainer;
